import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import videoCanvas from "video-canvas";
var wrapperStyles = {
  overflowY: "hidden",
  position: "static",
  width: "100%"
};
var styles = {
  fullScreen: {
    width: "100vw",
    height: "100vh",
    background: "aqua",
    position: "fixed",
    top: "0px",
    left: "0px"
  }
};

var CodeReader = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CodeReader, _Component);

  function CodeReader(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleSuccess", function (result) {
      _this.props.codeReader.stopStreams();

      _this.props.onCode(result.text);
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function (err) {
      console.log(err);
    });

    _this.state = _extends({}, props, {
      showPlaceholder: true
    });
    return _this;
  }

  var _proto = CodeReader.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.codeReader.stopStreams();
  };

  _proto.componentDidMount = /*#__PURE__*/function () {
    var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var videoInputDevices, firstDeviceId, video;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.props.codeReader.listVideoInputDevices();

            case 2:
              videoInputDevices = _context.sent;
              this.setState({
                devices: videoInputDevices
              });
              firstDeviceId = videoInputDevices[0].deviceId;
              this.props.codeReader.decodeOnceFromVideoDevice(firstDeviceId, "video").then(this.handleSuccess)["catch"](this.handleError);
              video = document.querySelector("video");
              videoCanvas(video, {
                canvas: document.querySelector("#video-canvas"),
                drawCall: function drawCall(ctx, video) {
                  ctx.fillStyle = "#fff";
                  ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                  var aspectWidth = ctx.canvas.width / ctx.canvas.offsetWidth;
                  var aspectHeight = ctx.canvas.height / ctx.canvas.offsetHeight;
                  ctx.drawImage(video, (ctx.canvas.offsetWidth - video.videoWidth) / 2 * aspectWidth, (ctx.canvas.offsetHeight - video.videoHeight) / 2 * aspectHeight, aspectWidth * video.videoWidth, aspectHeight * video.videoHeight);
                  ctx.beginPath();
                  var rectangleWidth = aspectWidth * (video.videoWidth - 250);
                  var rectangleHeight = aspectHeight * (video.videoHeight - 100);
                  ctx.lineWidth = 10;
                  ctx.strokeStyle = "rgba(100,100,100,0.5)";
                  ctx.rect((ctx.canvas.offsetWidth - ctx.canvas.width + 250) / 2 * aspectWidth, (ctx.canvas.offsetHeight - ctx.canvas.height + 100) / 2 * aspectHeight, rectangleWidth, rectangleHeight);
                  ctx.stroke();
                }
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentDidMount() {
      return _componentDidMount.apply(this, arguments);
    }

    return componentDidMount;
  }();

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.props.className,
      style: _extends({}, wrapperStyles, this.props.style)
    }, this.state.showPlaceholder ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)) : null, /*#__PURE__*/React.createElement("video", {
      id: "video",
      style: {
        display: "none"
      }
    }), /*#__PURE__*/React.createElement("canvas", {
      id: "video-canvas",
      style: styles.fullScreen
    }));
  };

  return CodeReader;
}(Component);

CodeReader.propTypes = process.env.NODE_ENV !== "production" ? {
  onInit: PropTypes.func,
  shouldDecode: PropTypes.bool,
  onCode: PropTypes.func,
  style: PropTypes.object,
  videoStyle: PropTypes.object,
  rearCamera: PropTypes.bool,
  className: PropTypes.string
} : {};
CodeReader.defaultProps = {
  onInit: function onInit() {},
  shouldDecode: true,
  onCode: function onCode() {},
  style: {},
  videoStyle: {},
  rearCamera: true,
  className: undefined
};
export default CodeReader;